import React from 'react';
import { Box, Typography } from '@mui/material';
import StatusPill from '../../components/statusPill';

const card = {
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.14)',
    borderRadius: '22px',
    p: 2.5,
};

const avatar = {
    height: 64, width: 64,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #0078FF, #00D7FF)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '1.5rem', fontWeight: 700, color: '#fff', flexShrink: 0,
};

// fix 7+8 — removed borderBottom dividers, using gap for spacing
const fieldRows = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',   // fix 8 — 12px gap between rows
    mt: '20px',    // fix 12 — was 24px (mb:3)
};

// fix 6 — label lineHeight 16px
const labelSx = {
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    color: 'var(--ecal-lightgrey)',
    lineHeight: '16px',
};

// fix 6 — value lineHeight 20px
const valueSx = {
    fontSize: '0.875rem',
    color: 'var(--ecal-white)',
    textAlign: 'right',
    lineHeight: '20px',
};

const rowSx = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 1.5,
};

function Row({ label, value }) {
    return (
        <Box sx={rowSx}>
            <Typography sx={labelSx}>{label}</Typography>
            <Typography sx={valueSx}>{value || '—'}</Typography>
        </Box>
    );
}

function ProfileDetails({ displayName, email, avatarInitials, personaType, city, country, timezone, connectedDevices }) {
    return (
        <Box sx={card}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={avatar}>{avatarInitials || '?'}</Box>
                <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '18px', color: 'var(--ecal-white)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {displayName || 'User'}
                    </Typography>
                    <Typography sx={{ fontSize: '12px', color: 'var(--ecal-lightgrey)', mt: 0.25 }}>
                        {email}
                    </Typography>
                    <Box sx={{ mt: '4px' }}>  {/* fix 10 — was mt:0.75 (6px) */}
                        <StatusPill isActive={true} />
                    </Box>
                </Box>
            </Box>

            <Box sx={fieldRows}>
                <Row label="Persona" value={personaType} />
                <Row label="Detected location" value={city && country ? `${city}, ${country}` : null} />
                <Row label="Timezone" value={timezone} />
                <Row label="Connected devices" value={connectedDevices} />
            </Box>
        </Box>
    );
}

export default ProfileDetails;
